export default class TicketMensagemTipoAtorEnum {
  static Cliente = { id: 1, nome: 'Cliente', descricao: 'Mensagem enviada pelo cliente.' }

  static Agente = { id: 2, nome: 'Agente', descricao: 'Mensagem enviada pelo agente.' }

  static Gestor = { id: 3, nome: 'Gestor', descricao: 'Mensagem enviada pelo gestor.' }
}
